import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock, Lock } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";

export default function Footer() {
  const { settings } = useSettings();
  const s = settings || {};

  return (
    <footer className="bg-[#0F1720] text-slate-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-10">
        <div className="md:col-span-1">
          <div className="flex items-center gap-2.5 mb-4">
            <div className="w-9 h-9 rounded-lg bg-[#E85D2A] text-white flex items-center justify-center font-display font-bold text-sm">ПП</div>
            <div className="leading-none">
              <div className="font-display font-bold text-base text-white">{s.company_name || "Пром-Пластик"}</div>
              <div className="text-[9px] tracking-[0.16em] text-slate-500 mt-0.5">{s.tagline}</div>
            </div>
          </div>
          <p className="text-sm text-slate-400 leading-relaxed">Производство стеновых и потолочных ПВХ-панелей. Прямые цены от завода.</p>
        </div>

        <div>
          <h4 className="text-white font-display font-semibold mb-4 text-sm uppercase tracking-wider">Разделы</h4>
          <ul className="grid grid-cols-2 gap-x-4 gap-y-2.5 text-sm">
            <li><Link to="/catalog" className="hover:text-[#E85D2A] transition-colors">Каталог</Link></li>
            <li><Link to="/services" className="hover:text-[#E85D2A] transition-colors">Услуги</Link></li>
            <li><Link to="/how-to-order" className="hover:text-[#E85D2A] transition-colors">Как заказать</Link></li>
            <li><Link to="/news" className="hover:text-[#E85D2A] transition-colors">Новости</Link></li>
            <li><Link to="/about" className="hover:text-[#E85D2A] transition-colors">О компании</Link></li>
            <li><Link to="/contacts" className="hover:text-[#E85D2A] transition-colors">Контакты</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-display font-semibold mb-4 text-sm uppercase tracking-wider">Контакты</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-2.5"><MapPin size={16} className="text-[#E85D2A] mt-0.5 shrink-0" /> {s.address}</li>
            <li className="flex items-center gap-2.5"><Clock size={16} className="text-[#E85D2A] shrink-0" /> {s.work_hours}</li>
            <li><a href={`tel:${s.phone_link}`} className="flex items-center gap-2.5 hover:text-[#E85D2A] transition-colors"><Phone size={16} className="text-[#E85D2A] shrink-0" /> {s.phone}</a></li>
            <li><a href={`mailto:${s.email}`} className="flex items-center gap-2.5 hover:text-[#E85D2A] transition-colors"><Mail size={16} className="text-[#E85D2A] shrink-0" /> {s.email}</a></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-display font-semibold mb-4 text-sm uppercase tracking-wider">Заказать</h4>
          <p className="text-sm text-slate-400 mb-4">Оставьте заявку — менеджер свяжется с вами и рассчитает стоимость.</p>
          <a href={`tel:${s.phone_link}`} className="inline-flex bg-[#E85D2A] hover:bg-[#D04A1B] text-white rounded-full px-6 py-2.5 text-sm font-medium transition-colors">Позвонить</a>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-500">
          <span>© {new Date().getFullYear()} {s.company_name || "Пром-Пластик"}. Все права защищены.</span>
          <div className="flex items-center gap-4">
            <Link to="/privacy" className="hover:text-slate-300 transition-colors">Политика конфиденциальности</Link>
            <Link to="/login" data-testid="footer-admin-link" title="Панель управления" className="inline-flex items-center gap-1 text-slate-600 hover:text-[#E85D2A] transition-colors"><Lock size={12} /> Вход</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
